import React from 'react';
import CTA from './CTA';
import HeaderSocials from './HeaderSocials.jsx';


const Header = () => {
  return (
    <header id='home' className="relative h-screen overflow-visible flex flex-col lg:flex-row justify-center items-center bg-pink-100 text-center">
      <div className="relative flex flex-col justify-center items-center text-center h-full lg:w-3/4 lg:pl-20">
        <h5 id="header" className="text-2xl font-medium font-poppins text-dark drop-shadow-lg">Hello I'm</h5>
        <h1 id="nombre" className="text-5xl font-bold font-poppins text-dark mt-4 mb-8">Romina Molina</h1>
        <h5 className="text-2xl text-dark">Full-Stack Developer</h5>
        <CTA />
        <HeaderSocials />
        <a href="#contact" className='hidden md:block absolute bottom-12 right-4 transform rotate-90 text-md text-dark hover:text-primary'>
        Scroll Down
      </a>
      </div>
      {/* <div className="hidden absolute md:flex md:relative md:top-20 md:left-20 lg:top-20 lg:left-20 mt-10 lg:ml-10 justify-center lg:justify-start items-center lg:items-start">
        <div className="w-48 h-48 md:w-56 md:h-56 lg:w-72 lg:h-72 rounded-full overflow-hidden border-4 border-primary">
          <img src={profileImage} alt="Profile" className="object-cover w-full h-full" />
        </div>
      </div> */}
    </header>
  );
};

export default Header;
